import { TaskAuthorComponent } from './task-author.component';

export const TaskAuthorModule = angular
  .module('sfMobile.components.taskAuthor', ['sfMobile.services.users'])
  .component('sfTaskAuthor', TaskAuthorComponent).name;
